import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Divider from '@mui/material/Divider';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
// import Circular from './Circularprogress';
// import Modalopener from './Modal.jsx';
// import Menuname from './Supplymenu.jsx';
import Search from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import Nodata from '../pages/nodatafound.jsx';
import { CROP_PRODUCT_OPTIONS } from '../constants/cropProducts';

import Circular from '../components/Circularprogress';
import Modalopener from '../modal/Modal.jsx';
import Menuname from '../menu/menudispatch.jsx';
import Modalviewer from '../modal/Modalview.jsx';
import Modaldelete from '../modal/Modaldelete.jsx';
import Modalprocess_ from '../modal/Modalprocessp.jsx';
import Modalediter from '../modal/Modalupdatereceive.jsx';

import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getadmin } from '../redux/admin';
import { getcustomer } from '../redux/customer';
import { getcommodity } from '../redux/commodity';

import { Modal } from '@mui/material';

function createData(
  id ,batch ,agent ,amountgiven ,expecteddate ,qty ,prefinancedate ,others ,product ,haullier ,vehicle ,qtyreceived ,unitqty ,community ,waybil ,datedispatched ,warehousereceived ,date ,  datereceived ,expunit, receiveunit, processingcenter, processingtype, rawqty, processdate, finishedqtyunit, status, customer, amountpaid, quantity, unitpaid
) {
  return {
    id ,batch ,agent ,amountgiven ,expecteddate ,qty ,prefinancedate ,others ,product ,haullier ,vehicle ,qtyreceived ,unitqty ,community ,waybil ,datedispatched ,warehousereceived ,date ,  datereceived ,expunit, receiveunit, processingcenter, processingtype, rawqty, processdate, finishedqtyunit, status, customer, amountpaid, quantity, unitpaid
  }
}

var rows = [
  createData(1, 'Cupcake', 305, 3.7, 67, 4.3),
  createData(2, 'Donut', 452, 25.0, 51, 4.9),
  createData(3, 'Eclair', 262, 16.0, 24, 6.0),
  createData(4, 'Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData(5, 'Gingerbread', 356, 16.0, 49, 3.9),
  createData(6, 'Honeycomb', 408, 3.2, 87, 6.5),
  createData(7, 'Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData(8, 'Jelly Bean', 375, 0.0, 94, 0.0),
  createData(9, 'KitKat', 518, 26.0, 65, 7.0),
  createData(10, 'Lollipop', 392, 0.2, 98, 0.0),
  createData(11, 'Marshmallow', 318, 0, 81, 2.0),
  createData(12, 'Nougat', 360, 19.0, 9, 37.0),
  createData(13, 'Oreo', 437, 18.0, 63, 4.0),
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [

  {
    id: 'product',
    numeric: false,
    disablePadding: false,
    label: 'Product',
  },
  {
    id: 'agent',
    numeric: true,
    disablePadding: false,
    label: 'Agent Name',
  },
  {
    id: 'quantity',
    numeric: true,
    disablePadding: false,
    label: 'Quantity',
  },
  {
    id: 'warehouse',
    numeric: true,
    disablePadding: false,
    label: 'Warehouse',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
  }, 
  {
    id: 'date',
    numeric: true,
    disablePadding: false,
    label: 'Date Received',
  }, 
  
 
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
    
        {headCells.map((headCell) => (
          <TableCell
          style={{fontWeight:"bolder"}}
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;
  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        },
      ]}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Nutrition
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function EnhancedTable() {
    const dt = new Date()
    const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    const day = dt.getUTCDate();
    const month = String(dt.getMonth() + 1).padStart(2, '0');
    const year = dt.getFullYear();
    const date = year + "-" + month + "-" + day;
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

    
  const dispatch = useDispatch()
  const admin = useSelector((state) => state.admin)
  const customer = useSelector((state) => state.customer)
  const commodity = useSelector((state) => state.purchase)
  const warehouse = useSelector((state) => state.warehouse)

  var sortcommodity = commodity.filter(bug=>bug.status==="Despatched")
  var rows_ = [(sortcommodity || []).map((list, index) => createData(  list._id ,list.batch ,list.agent ,list.amountgiven ,list.expecteddate ,list.qty ,list.prefinancedate ,list.others ,list.product ,list.haullier ,list.vehicle ,list.qtyreceived ,list.unitqty ,list.community ,list.waybil ,list.datedispatched ,list.warehousereceived ,list.date ,  list.datereceived ,list.expunit, list.receiveunit, list.processingcenter, list.processingtype, list.rawqty, list.processdate, list.finishedqtyunit, list.status, list.customer, list.amountpaid, list.quantity, list.unitpaid, list.month, list.year, list.balance ))]
  var rows=rows_.length===1 ? rows_[0] :[]
//   var rows = [product.map((list, index) => createData(list._id, list.name, list.gender, list.contact, list.address, list.businesstype, list.interest, list.others))]


  const [order, setOrder] = React.useState('asc');
  const [Modalvalue, setModalvalue] = React.useState(false);
  const [Modalview, setModalview] = React.useState(false);
  const [Modaldeleter, setModaldeleter] = React.useState(false);
  const [Modaledit, setModaledit] = React.useState(false);
  const [Modalprocess, setModalprocess] = React.useState(false);
  const [Modaldispatch, setModaldispatch] = React.useState(false);
  const [Chosen, setChosen] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [search, setSearch] = React.useState("")
  const [bymonth, setbymonth] = React.useState('none');
  const [byyear, setbyyear] = React.useState('none');
  const [byproduct, setbyproduct] = React.useState('none');
  const [bywarehouse, setbywarehouse] = React.useState('none');

  var datepusher=[]


  const searching = React.useCallback((e) => {
    setSearch(e.target.value);
    setPage(0); // Reset to first page when searching
  }, []);

  const filteredRows = React.useMemo(() => {
    if (!search) return rows;
    
    const searchLower = search.toLowerCase();
    return rows.filter(row => 
      Object.values(row).some(value => 
        value && 
        typeof value === 'string' && 
        value.toLowerCase().includes(searchLower)
      )
    );
  }, [search, rows]);

  const visibleRows = React.useMemo(() => {
    const sortedRows = [...filteredRows].sort(getComparator(order, orderBy));
    return sortedRows.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [filteredRows, order, orderBy, page, rowsPerPage]);

  const emptyRows = React.useMemo(() => {
    return page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredRows.length) : 0;
  }, [page, rowsPerPage, filteredRows.length]);

  React.useEffect(() => {
    if (search !== "") {
      const listed = rows_.length === 1 ? rows_[0].filter(item => 
        (item.batch && item.batch.toLowerCase().includes(search.toLowerCase())) ||
        (item.agent && item.agent.toLowerCase().includes(search.toLowerCase())) ||
        (item.community && item.community.toLowerCase().includes(search.toLowerCase())) ||
        (item.warehousereceived && item.warehousereceived.toLowerCase().includes(search.toLowerCase())) ||
        (item.id && item.id.toLowerCase().includes(search.toLowerCase()))
      ) : [];
      rows=listed;
    } else {
      rows=rows_.length===1 ? rows_[0] :[]
    }
  }, [search, rows_]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const showdata=(event, data)=>{
    
    setModalvalue(true)
 
    setChosen(data)
  }

  const setoff=()=>{
    setModalvalue(false)
    setModaldeleter(false)
    setModaledit(false)
    setModalprocess(false)
    setModaldispatch(false)

  }
 

  const setoffer=()=>{
    setModalview(false)
    setModaldeleter(false)
    setModaledit(false)
    setModalprocess(false)
    setModaldispatch(false)

  }

  
  const setview=()=>{
    setModalview(true)
    
  }

const setdeleter=()=>{
    setModaldeleter(true)

  }
const setedit=()=>{
    setModaledit(true)

  }
const setprocess=()=>{
    setModalprocess(true)

  }

const setdispatch=()=>{
    setModaldispatch(true)

  }

  
const sortermonth=(e)=>{
  setbymonth(e.target.value)
  
if(byyear==="none" || bymonth==="none"){
  rows=rows_
}else{
  var lister = rows_.filter(bug=> bug.year===byyear && bug.month===bymonth)
  rows=rows_
}

}


const sorteryear=(e)=>{
  setbyyear(e.target.value)
  
if(byyear==="none" || bymonth==="none"){
  rows=rows_
}else{
  var lister = rows_.filter(bug=> bug.year===byyear && bug.month===bymonth)
  rows=rows_
}

}



const warehousesorter=(e)=>{
  setbywarehouse(e.target.value)
  
if(bywarehouse==="none" ){
  rows=rows_
}else{
  var lister = rows_.filter(bug=> bug.status===bywarehouse)
  rows=rows_
}

}


const productsorter=(e)=>{
  setbyproduct(e.target.value)
  
if(byproduct==="none" ){
  rows=rows_
}else{
  var lister = rows_.filter(bug=> bug.status===byproduct)
  rows=rows_
}

}

for(var i=0; i<=11;i++){
  datepusher.push(year-i)

}

  return (
    <Box sx={{ width: '100%' }}>
   
    {Modalvalue===true &&  <Modalopener  value={Modalvalue} chosen={Chosen} product={Chosen.name} setfalse={setoff} name="Received Goods"  Menu={<Menuname  name="Received Goods" chosen={Chosen} value={Modalview} view={setview} delete={setdeleter}  edit={setedit} process={setprocess}  dispatch={setdispatch} product={Chosen.name}  />}/>  }
    {Modalview===true &&  <Modalviewer name="Received Goods"  product={Chosen.name} chosen={Chosen} view={setview} setfalser={setoffer} value={Modalvalue}/>}
    {Modaldeleter===true &&  <Modaldelete name="Received Goods" delete={"commodity"} dispatcher={getcommodity}   product={Chosen.name} chosen={Chosen}  view={setdeleter} setfalser={setoffer} value={Modaldeleter}/>}
    {Modaledit===true &&  <Modalediter name="Received Goods"  product={Chosen.name} chosen={Chosen}  view={setedit} setfalser={setoffer} value={Modaledit}/>}
    {Modalprocess===true &&  <Modalprocess_ name="Process Goods"  product={Chosen.name} chosen={Chosen}  view={setprocess} setfalser={setoffer} value={Modalprocess}/>}
    {Modaldispatch===true &&  <Modalprocess_ name="Dispatch Goods"  product={Chosen.name} chosen={Chosen}  view={setprocess} setfalser={setoffer} value={Modaldispatch}/>}
     
     
     
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
           
        <div style={{padding:"10px"}}>

<Grid container>
                    <Grid lg={4} xs={2} md={6}>
                      
                    <TextField
                    style={{marginTop:"8px"}}
          id="outlined-select-currency-native"
          select
          label="Sort By month"
          // defaultValue="Ownership Type"
          value={bymonth}
          size="small"
          onChange={(e)=>sortermonth(e)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
            <option key="none" value="none">Choose Month</option>
            {months.map((index,i)=>
           <option key={index} value={index}>{index}</option>
          )}
        
        </TextField>  
        <TextField
                    style={{marginTop:"8px", marginLeft:"10px"}}
          id="outlined-select-currency-native"
          select
          label="Sort By year"
          // defaultValue="Ownership Type"
          value={byyear}
          size="small"
          onChange={(e)=>sorteryear(e)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
          <option key="none" value="none">Choose Year</option>
        
          {datepusher.map((index,i)=>
           <option key={index} value={index}>{index}</option>
          )}
                             
        </TextField>   

                    </Grid>
                  
                    <Grid lg={4} xs={2} md={6} style={{textAlign:"center"}}>
                      
 <div style={{position:"relative"}}> 
    
                    <Search id="searchbox"  style={{ position: "absolute", marginTop: "18px", marginLeft: "8px", color:"grey" }} /> <input type="search" onChange={(e) => searching(e)} placeholder="Search" style={{ padding: 10, paddingLeft: "38px", marginTop: 10, width: "100%", border: "solid", borderRadius: "5px", borderWidth: "0.5px", backgroundColor: "rgba(65,105,225, 0.05) ", borderColor: "#2196f3" }} />
                    </div> 

                    </Grid>

                    <Grid lg={4} xs={10} md={6}>
                    <TextField
                    style={{marginTop:"8px", marginLeft:"8px"}}
          id="outlined-select-currency-native"
          select
          label="Sort By Warehouse"
          // defaultValue="Ownership Type"
          value={bywarehouse}
          size="small"
          onChange={(e)=>warehousesorter(e)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
            <option key="none" value="none">All</option>
          {
            warehouse.map((list, i)=>
              <option key={list.warehousename} value={list.warehousename}> {list.warehousename} </option>

            )
          }
        
        </TextField>     
        
         <TextField
                    style={{marginTop:"8px", marginLeft:"8px"}}
          id="outlined-select-currency-native"
          select
          label="Sort By Product"
          // defaultValue="Ownership Type"
          value={byproduct}
          size="small"
          onChange={(e)=>productsorter(e)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
            
            <option key="none" value="none">All</option>
            {CROP_PRODUCT_OPTIONS.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
           
        
        </TextField> 
                    {/* <p style={{marginLeft:"20px", textAlign:"center",fontSize:"160%", marginTop:"5px"}}> <span>GHC </span> 200  <span style={{fontSize:"12px"}}>Total Given</span> </p> */}

                    </Grid>

                    <Grid lg={4} xs={10} md={6}>
                    {/* <TextField
                    style={{marginTop:"8px"}}
          id="outlined-select-currency-native"
          select
          label="Sort By Status"
          // defaultValue="Ownership Type"
          value={bymonth}
          size="small"
          onChange={(e)=>setbymonth(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
            <option key="none" value="none">All</option>
            <option key="Received" value="Received">Received</option>
            <option key="Expected" value="Expected">Expected</option>
            <option key="Pending" value="Pending">Pending</option>
            <option key="Dispatched" value="Dispatched">Dispatched</option>
           
        
        </TextField>   */}
                    {/* <p style={{marginLeft:"2px", fontSize:"160%", marginTop:"5px", marginBottom:"-10px"}}> <span>GHC </span> 200  <span style={{fontSize:"12px", color:"lightblue"}}>Total Given</span> </p> */}

                    </Grid>

                    
                </Grid>

</div>
<Divider/>

          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              // onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
            {rows.map((row, index) => {
                const isItemSelected = selected.includes(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    onClick={(event)=>showdata(event, row)}
                    role="checkbox"
                    // aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    // selected={isItemSelected}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell
                    
                      // component="th"
                      id={labelId}
                      scope="row"
                      // padding="normal"
                    >
                       {row.batch}
                    </TableCell>
                    <TableCell align="left">{row.agent}</TableCell>
                    <TableCell align="left">{row.qty}</TableCell>
                    <TableCell align="left">{row.warehousereceived}</TableCell>
                    <TableCell align="left">{row.status}</TableCell>
                    <TableCell align="left">{row.datereceived}</TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        {rows.length===0 && <Nodata/>}
          
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[30, 40, 50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </Box>
  );
}
